import {
    createGlobalStyle
} from "styled-components"
export const GlobalStyles = createGlobalStyle `
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: Tahoma, Helvetica, Arial, Roboto, sans-serif;
    transition: all 0.50s linear;
    height: auto;
  }
  .btn-secondary {
    background: ${({ theme }) => theme.boxColor};
  }
  .kpiBoxItem,
  .filterExpensesItem,
  .filterExpenses,
  .listTenExpenses {
    background: ${({ theme }) => theme.boxColor};
    color: ${({ theme }) => theme.text};
  }
  .inputField,
  .Dropdown-menu,
  .Dropdown-control,
  .label  {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
  }
  .Dropdown-option{
    color: ${({ theme }) => theme.text};
  }
  .popup-content  {
    background: ${({ theme }) => theme.body};
    border: 1px solid ${({ theme }) => theme.boxColor};
  }
  .kpiWeekValue,
  .kpiMonthValue,
  .kpiAllTimeValue {
    color: ${({ theme }) => theme.kpiColor};
  }
  .expenseItem, .categoryItem, .memberItem {
    background-color: ${({ theme }) => theme.item};
    color: ${({ theme }) => theme.text};
  }
  rect {
    fill: ${({ theme }) => theme.body};
  }
  strong{
    color: ${({ theme }) => theme.text};
  }
  `